import { css } from '@eti/styles';
import { breakpoints, Card, Column, Columns, Stack } from '@etg/wings';
import { type TripCharacteristics, type BoundNew } from '@eti/schema-types';
import { useMediaQuery } from 'usehooks-ts';
import OnceWayTicketCombinationBadge from '../../../../../common/components/OneWayTicketCombinationBadge';
import type {
  AvailableExtraProductsType,
  IncludedCabinBaggageType,
  IncludedCheckedBaggageType,
} from '../../../../result/models';
import SelectedTripBaggageInfo from './SelectedTripBaggageInfo';
import ItineraryInfoSection from './ItineraryInfoSection';
import SelectedTripFarePrice from './SelectedTripFarePrice';
import SelectedTripBanner from './banner/SelectedTripBanner';

const cardStyles = css`
  margin-top: 16px;
`;

const stackStyles = css`
  padding: 16px;
`;

interface SelectedTripCardProps {
  availableExtraProducts: AvailableExtraProductsType;
  bounds: BoundNew[];
  includedCabinBaggage: IncludedCabinBaggageType;
  includedCheckedBaggage: IncludedCheckedBaggageType;
  selectedTripPricePerAdult: number;
  tripCharacteristics: TripCharacteristics[];
}

const SelectedTripCard = ({
  availableExtraProducts,
  bounds,
  includedCabinBaggage,
  includedCheckedBaggage,
  selectedTripPricePerAdult,
  tripCharacteristics,
}: SelectedTripCardProps) => {
  const isWiderViewport = useMediaQuery(`(min-width: ${breakpoints._768})`);

  return (
    <Card className={cardStyles} data-testid="selected-trip-card" padding={0}>
      <Columns spacing={0}>
        <Column width={{ [breakpoints._0]: '4/4', [breakpoints._768]: '2/4' }}>
          <Stack className={stackStyles}>
            <ItineraryInfoSection bounds={bounds} />
            <OnceWayTicketCombinationBadge
              bounds={bounds}
              tripCharacteristics={tripCharacteristics}
            />
            <SelectedTripBaggageInfo
              availableExtraProducts={availableExtraProducts}
              bounds={bounds}
              includedCabinBaggage={includedCabinBaggage}
              includedCheckedBaggage={includedCheckedBaggage}
            />
            <SelectedTripFarePrice selectedTripPricePerAdult={selectedTripPricePerAdult} />
          </Stack>
        </Column>
        {isWiderViewport && (
          <Column>
            <SelectedTripBanner />
          </Column>
        )}
      </Columns>
    </Card>
  );
};

export default SelectedTripCard;
